import axios from 'axios';
const api = axios.create({baseURL:'http://realitycygars.ddns.net:9000'});
api.defaults.headers.common = { Authorization : `bearer ${localStorage.getItem('usenet-token')}` };
export default api;